// client/src/services/user.js
import { v4 as uuidv4 } from 'uuid';

// Diese Funktion stellt sicher, dass jeder Client eine persistente Nutzer-ID bekommt.
export function getPersistentUserId() {
    let id = localStorage.getItem('persistentUserId');
    if (!id) {
        id = uuidv4();
        localStorage.setItem('persistentUserId', id);
    }
    return id;
}

// Holt den Benutzernamen aus dem localStorage
export function getUserName() {
    return localStorage.getItem('userName') || '';
}
